<template>
    <!--    Don't touch this, or you risk both your arms and a leg broken-->
    <!--    This might (read: WILL!) happen-->

    <!--    runtime-core.esm-bundler.js:40-->
    <!--    [Vue warn]: Hydration text mismatch:-->
    <!--    - Client: " From £2,730.00"-->
    <!--    - Server: " From "-->
    <span>{{ format(data) }}</span>
</template>

<script lang="ts" setup>
import type { MoneyFragment } from '@/graphql/api'
import {
    type MoneyFormatter,
    useMoneyFormatter,
} from '@/plugins/money-formatter.ts'

const props = defineProps<{
    data: MoneyFragment
    formatter?: MoneyFormatter
}>()

const format = props.formatter ?? useMoneyFormatter()
</script>
